import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, Container, MenuItem, TextField, Typography } from '@mui/material';
import AppHeader from '../AppHeader';
import { useCurrentSiteId } from '../../hooks/useCurrentSiteId';
import { programAPI, saveBlob } from '../../services/api';

export default function StudentAttendanceRecordPage() {
  const siteId = useCurrentSiteId();
  const [students, setStudents] = useState([]);
  const [classNum, setClassNum] = useState('all');
  const [studentId, setStudentId] = useState('all');
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    programAPI.studentAttendance({ class: 'all' }).then((res) => {
      if (!cancelled) setStudents(res.data.students || []);
    }).catch(() => {
      if (!cancelled) setError('The attendance list did not load.');
    });
    return () => { cancelled = true; };
  }, [siteId]);

  const classes = [...new Set(students.map((row) => row.class).filter(Boolean))];
  const shown = classNum === 'all' ? students : students.filter((row) => String(row.class) === String(classNum));

  const print = () => {
    setError('');
    programAPI.studentAttendancePdf({ class: classNum, student: studentId }).then((res) => {
      saveBlob(res.data, 'student-attendance-record.pdf');
    }).catch(() => setError('The attendance record did not print.'));
  };

  return (
    <>
      <AppHeader backTo="/reports" rightContent={<Typography variant="subtitle1">Student attendance record</Typography>} />
      <Container sx={{ py: 2 }}>
        <Typography variant="body2" sx={{ mb: 2 }}>
          One page per child, September through June. Center Based. Off days from the school calendar are shaded. This does not change the monthly class log.
        </Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
          <TextField select size="small" label="Class" value={classNum} onChange={(e) => { setClassNum(e.target.value); setStudentId('all'); }} sx={{ minWidth: 140 }}>
            <MenuItem value="all">All</MenuItem>
            {classes.map((item) => <MenuItem key={item} value={item}>Class {item}</MenuItem>)}
          </TextField>
          <TextField select size="small" label="Student" value={studentId} onChange={(e) => setStudentId(e.target.value)} sx={{ minWidth: 220 }}>
            <MenuItem value="all">All</MenuItem>
            {shown.map((row) => (
              <MenuItem key={row.id} value={String(row.id)}>{row.last_name}, {row.first_name}</MenuItem>
            ))}
          </TextField>
          <Button variant="contained" onClick={print} disabled={!shown.length}>PDF</Button>
        </Box>
        {!students.length && !error && (
          <Alert severity="info" sx={{ mt: 2 }}>No children in this session.</Alert>
        )}
      </Container>
    </>
  );
}
